import React from 'react';
import { Button } from 'semantic-ui-react';
import { INTERVAL_OPTIONS } from './chartIntervals';
import './DateRangeFilter.scss';

interface DateRangeFilterProps {
  value: string;
  onChange: (value: string) => void;
}

const DateRangeFilter: React.FC<DateRangeFilterProps> = ({ value, onChange }) => {
  return (
    <div>
      <Button.Group id='date-range-filter' size="small">
        {INTERVAL_OPTIONS.map((opt) => (
          <Button
            key={opt.key}
            toggle
            active={value === opt.value}
            onClick={() => onChange(opt.value)}
          >
            {opt.text}
          </Button>
        ))}
      </Button.Group>
    </div>
  );
};

export default DateRangeFilter;
